var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuoteCtrl = function () {
    function QuoteCtrl(StateUtils, ViewModelService, EndorsementService, $q, ModalService, paymentType) {
        var _this = this;

        _classCallCheck(this, QuoteCtrl);

        this.EndorsementService = EndorsementService;
        this.ModalService = ModalService;
        this.$q = $q;
        this.flowModel = StateUtils.activeDataForState(true).flowModel;

        this.$onInit = function () {
            _this.model = StateUtils.activeDataForState(true).model;

            _this.payInFullFlag = false;
            _this.paymentPlan = _this.model.paymentPlan.value;
            _this.changeInCost = _this.model.transactionCost.value;
            _this.effectiveDate = _this.model.baseData.effectiveDate.value;
            _this.startDate = _this.model.baseData.periodStartDate.value;
            _this.endDate = _this.model.baseData.periodEndDate.value;
            _this.payInFull = _this.payInFull.bind(_this);
            _this.hidePayInFull = _this.hidePayInFull.bind(_this);
            _this.paymentType = paymentType;

            _this.paymentDetails = {
                paymentMethod: _this.paymentType.WIRE,
                creditCardData: {},
                bankAccountData: {}
            };

            _this.paymentView = ViewModelService.create(_this.paymentDetails, 'pc', 'edge.capabilities.policyjob.binding.dto.PaymentDetailsDTO');
        };
    }

    _createClass(QuoteCtrl, [{
        key: 'payInFull',
        value: function payInFull(nextFn, form) {
            var _this2 = this;

            if (form.invalid) {
                return nextFn();
            }
            this.bind().then(function () {
                return _this2.flowModel.next(_this2.model);
            });
        }
    }, {
        key: 'redistribute',
        value: function redistribute() {
            var _this3 = this;

            this.paymentDetails.paymentMethod = 'redistribute';
            this.bind().then(function () {
                return _this3.flowModel.next(_this3.model);
            });
        }
    }, {
        key: 'isWire',
        value: function isWire() {
            return this.paymentDetails.paymentMethod === this.paymentType.WIRE;
        }
    }, {
        key: 'isCreditCard',
        value: function isCreditCard() {
            return this.paymentDetails.paymentMethod === this.paymentType.CREDIT_CARD;
        }
    }, {
        key: 'displayPayInFull',
        value: function displayPayInFull() {
            this.payInFullFlag = true;
        }
    }, {
        key: 'hidePayInFull',
        value: function hidePayInFull() {
            this.payInFullFlag = false;
        }
    }, {
        key: 'bind',
        value: function bind() {
            var _this4 = this;

            switch (this.paymentDetails.paymentMethod) {
                case this.paymentType.WIRE:
                    delete this.paymentDetails.creditCardData;
                    break;
                case this.paymentType.CREDIT_CARD:
                    delete this.paymentDetails.bankAccountData;
                    break;
                case this.paymentType.REDISTRIBUTE:
                    delete this.paymentDetails.creditCardData;
                    delete this.paymentDetails.bankAccountData;
                    break;
                default:
                    delete this.paymentDetails.creditCardData;
                    delete this.paymentDetails.bankAccountData;
            }

            var deferred = this.$q.defer();
            this.EndorsementService.bind(this.model.jobID.value, this.paymentDetails).then(function () {
                return deferred.resolve();
            }).catch(function () {
                return _this4.ModalService.showError('gw-portals-policytransaction-common-angular.components.payment.paymentCtrl.Error binding transaction', 'gw-portals-policytransaction-common-angular.components.payment.paymentCtrl.Please check for errors and try again');
            });
            return deferred.promise;
        }
    }]);

    return QuoteCtrl;
}();

QuoteCtrl.$inject = ['StateUtils', 'ViewModelService', 'endorsement.EndorsementService', '$q', 'ModalService', 'paymentType'];

export default QuoteCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-common-angular/components/payment/paymentCtrl.js
// module id = 1844
// module chunks = 0